import { EMPTY_WORKSTATION_STATE, WorkstationState } from '@connect-x-app/shared-domain-models';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';

export const isWorkstationEmpty = (workstation?: WorkstationState | null) => {
  if (!workstation) {
    return true;
  }

  const workstationToCompare = omit(workstation, 'workstationId');
  const emptyStateToCompare = omit(EMPTY_WORKSTATION_STATE, 'workstationId');

  return isEqual(workstationToCompare, emptyStateToCompare);
};
